const BASE_URL = "https://realtyapp.realtyitsolutions.com/api/";

export const PROPERTIES_URL = BASE_URL + "webpropertieslist";
export const PROPERTY_DETAIL_URL = BASE_URL + "webpropertydetails";
export const PROPERTY_TYPE_URL = BASE_URL + "webpropertytypeslist";
export const PROPERTY_SUGGESTIONS_URL = BASE_URL + "webpropertysuggestions";
export const AGENTS_URL = BASE_URL + "agentlist";
export const AGENT_DETAILS_URL = BASE_URL + "agentdetails";
export const CONTACT_AGENT_URL = BASE_URL + "savecontactagent/0";
export const REQUEST_A_TOUR_URL = BASE_URL + "savecontactagent/0"; //addtourrequest
export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
